import React from 'react';
import { HelpCircleIcon, HourglassIcon, LayersIcon, RouteIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { problems } from '../data/content';
const ICONS = {
  layers: LayersIcon,
  question: HelpCircleIcon,
  route: RouteIcon,
  hourglass: HourglassIcon
};
export function ProblemSection() {
  return <section aria-labelledby="problema" className="bg-white text-party-ink" data-id="element-137" data-mp="2vowogua3en5p">
      <div className="mx-auto max-w-2xl px-3 py-5 text-center sm:px-5" data-id="element-138" data-mp="39guqkl5dzisd">
        <p className="inline-block rounded bg-party-rose px-2 py-0.5 font-sans text-[0.62rem] font-bold uppercase tracking-[0.14em] text-white" data-id="element-139" data-mp="35gtyhxpd792u">
          ¿Te suena familiar?
        </p>
        <h2 id="problema" className="mt-1.5 font-display text-lg font-extrabold leading-tight sm:text-2xl" data-id="element-140" data-mp="3egz3k1735vdu">
          Quieres aprender a decorar fiestas y eventos, pero{' '}
          <span className="bg-party-pastel px-1" data-id="element-141" data-mp="1k37mwhqcab8w">
            no sabes por dónde empezar.
          </span>
        </h2>
        <p className="mx-auto mt-1.5 max-w-xl text-[0.8rem] leading-snug text-party-ink/75" data-id="element-142" data-mp="jdwlr0kttsxy">
          Si estás comenzando desde cero o quieres convertir esta habilidad en
          un nuevo servicio, probablemente conozcas alguna de estas situaciones:
        </p>

        <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-143" data-mp="x4i6kutuccyh">
          {problems.map((problem, i) => {
          const Icon = ICONS[problem.icon];
          return <Reveal key={problem.title} as="li" delay={i * 0.03} className="flex h-full gap-2.5 rounded-lg border-l-4 border-party-rose bg-party-cream p-2.5 text-left" data-id="element-144" data-mp="123cziplivhwb" data-mpi={i}>
                <span className="flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-md bg-party-rose" data-id="element-145" data-mp="1g3w5zsacafwd">
                  <Icon size={15} className="text-white" data-id="element-146" data-mp="3dtxbxl7jmq7k" />
                </span>
                <div data-id="element-147" data-mp="3hu7jv3ewbqp2">
                  <h3 className="font-sans text-[0.8rem] font-extrabold uppercase leading-tight" data-id="element-148" data-mp="3hvsd8pph53lc">
                    {problem.title}
                  </h3>
                  <p className="mt-0.5 text-[0.76rem] leading-snug text-party-ink/75" data-id="element-149" data-mp="k15vg5ez3061">
                    {problem.desc}
                  </p>
                </div>
              </Reveal>;
        })}
        </ul>
      </div>
    </section>;
}